import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppFilter } from 'app/models/app-filter.model';
import { AbDispositivoZeladoria } from 'app/abstract/full-pages/zelador-ia/dispositivo-zeladoria.abstract';

@Injectable({ providedIn: 'root' })
export class DispositivoZeladoriaService extends AbDispositivoZeladoria {

  constructor(http: HttpClient) {
    super(http);
  }

  public validarSerial(serialNumber: string): Observable<any> {
    return this.get(`api/v1/zelador-ia/dispositivos/validar-serial/${serialNumber}`);
  }

  public salvar(dispositivo: any): Observable<any> {
    return this.save('api/v1/zelador-ia/dispositivos/', dispositivo);
  }

  public buscarPorId(id: number): Observable<any> {
    return this.get(`api/v1/zelador-ia/dispositivos/${id}/info`);
  }

  public listar(filter: AppFilter): Observable<any> {
    return this.get(`api/v1/zelador-ia/dispositivos/${filter.encode()}`);
  }

  public editar(id: number, dispositivo: any): Observable<any> {
    return this.put('api/v1/zelador-ia/dispositivos', id, dispositivo);
  }

  public deletar(id: number): Observable<any> {
    return this.delete('api/v1/zelador-ia/dispositivos/', id);
  }

  public buscarStatus(id: number): Observable<any> {
    return this.get(`api/v1/zelador-ia/dispositivos/${id}/status`);
  }

  public buscarDashboard(id: number, filter: AppFilter): Observable<any> {
    return this.get(`api/v1/zelador-ia/dispositivos/${id}/dashboard/${filter.encode()}`);
  }

  public buscarHistorico(id: number, tipo: string, filter: AppFilter): Observable<any> {
    return this.get(`api/v1/zelador-ia/dispositivos/${id}/historico/${tipo}/${filter.encode()}`);
  }

  public getFeatureFlag(): Observable<any> {
    return this.get('api/v1/zelador-ia/feature-flag');
  }

  public listarDispositivosAtivos(): Observable<any> {
    return this.get('api/v1/zelador-ia/notificacoes/dispositivos');
  }
}
